import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiService } from '../../../../core/services/ApiService';
import { IPriorityShape, ISeatsWeight } from '../../interfaces';

@Injectable({
  providedIn: 'root'
})
export class WeightApiService{

  protected readonly _basePath = '/auditoriums/seat-definitions/weight';

  private readonly _apiService = inject(ApiService);

  public setSeatsWeights(payload: IPriorityShape & { seatsWeights: ISeatsWeight[] }): Observable<void> {
    return this._apiService.put(this._basePath, payload);
  }
}
